// Export centralisé de toutes les APIs
export * from './blog'
export * from './bug-reports'
export * from './graffitis'
export * from './http'
export * from './references'
export * from './system'
export * from './thematiques'
export * from './users'

// Export d'un objet API global pour faciliter l'usage
import { blogApi } from './blog'
import { bugReportsApi } from './bug-reports'
import { graffitisApi } from './graffitis'
import { referencesApi } from './references'
import { systemApi } from './system'
import { thematiquesApi } from './thematiques'

export const api = {
  blog: blogApi,
  graffitis: graffitisApi,
  thematiques: thematiquesApi,
  references: referencesApi,
  system: systemApi,
  bugReports: bugReportsApi,
}

// Export des types backup
export type { Backup, BackupCompatibility, BackupStats } from './system'
